var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DetailsBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var _a = store.newCreateRequestStore, detailStore = _a.detailStore, progressStore = _a.progressStore, problemStore = _a.problemStore, homeStore = _a.homeStore;
    var propsConnect = {
        currentUser: homeStore.currentUser,
        additionalDetail: detailStore.additionalDetail,
        attachmentList: detailStore.attachmentList,
        problemCaseCadeName: problemStore.problemCaseCadeName,
        currentIconUrl: problemStore.currentIconUrl,
        isAliasingView: problemStore.isAliasingView,
        level: problemStore.level,
    };
    var dispatchConnect = {
        setAdditionalDetail: detailStore.setAdditionalDetail,
        getDetailNextButtonDisable: detailStore.getDetailNextButtonDisable,
        uploadAttachment: detailStore.uploadAttachment,
        deleteAttachment: detailStore.deleteAttachment,
        next: progressStore.next,
        setLevel: function (level) { return problemStore.setProblemLevel(level); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
